export default __webpack_public_path__ + "static/media/note_added.e5141505.png";